import ApplicationController from "../turbo/application_controller";
import { debounce } from "lodash";
import { focusAndSelectAll } from "../lib/dom";
import { postJSON } from "../lib/http";

export default class extends ApplicationController {
    initialize() {
        this.update_name = debounce(this.update_name, 1000).bind(this);
    }

    update_name() {
        const section = this.targets.element;
        const sectionName = section.querySelector(".section_name");
        const newName = sectionName.innerText;

        section.querySelector(".overlay .section-name").innerText = `"${newName}"`;

        postJSON(sectionName.dataset.url, { name: newName });
    }

    select_all() {
        const section = this.targets.element.querySelector(".section_name");
        focusAndSelectAll(section);
    }
}
